<div id="app" class="app h-100" [ngClass]="settings.skin">
  <router-outlet></router-outlet>
</div>